export const extract = {
	title: "Extracto de vendor",
	placeAvaliable: "Su saldo disponible",
	anticipationBalance: "Su saldo disponible para anticipación",
	period: "Período",
	requiredField: "Campo obligatorio",
	tabs: {
		withdraws: {
			title: "Solicitudes financieras",
			export: "Exportar a Excel",
			columns: {
				vendorName: "Vendor",
				totalAvailable: "Saldo",
				type: {
					label: "Tipo",
					Withdraw: "Retiro",
					Anticipation: "Anticipación",
				},
				totalRequestedValue: "Valor",
			},
			sheet: {
				title: "Extracto de vendor",
				filename: "extracto-vendor",
				columns: {
					vendorName: "Vendor",
					requestDate: "Fecha",
					availableValue: "Saldo",
					withdrawValue: "Solicitud de retiro",
					anticipationValue: "Solicitud de anticipación",
				},
			},
		},
		history: {
			title: "Historial",
			export: "Exportar a Excel",
			columns: {
				requestDate: "Fecha",
				vendorName: "Vendor",
				status: "Estado",
				paymentMethod: "Método de pago",
				attachments: "Anexos",
				attachment: "Anexo",
				withdrawValue: "Valor",
				anticipationValue: "Valor de anticipación",
				proRataFee: "Tasa de prorrata",
				type: "Tipo",
			},
			receiptNotAvailable: "Comprobante no disponible",
			retryReceipt: "Generar nuevo comprobante",
			retryReceiptSuccess: "¡Comprobante generado con éxito!",
			retryReceiptError: "Error al generar nuevo comprobante",
			labels: {
				paid: "Pagado",
				processing: "Procesando",
				pending: "Pendiente",
				refused: "Rechazado",
			},
			sheet: {
				title: "Extracto de vendor",
				filename: "extracto-vendor",
				columns: {
					requestDate: "Fecha",
					vendorName: "Vendor",
					status: "Estado",
					paymentMethod: "Método de pago",
					withdrawValue: "Valor",
				},
			},
		},
		adjustments: {
			title: "Ajustes",
			export: "Exportar a Excel",
			add: "Agregar Ajuste",

			sheet: {
				title: "Extracto de vendor",
				filename: "extracto-vendor",
				columns: {
					originalPayDate: "Fecha de competencia",
					date: "Fecha de liquidación",
					vendorName: "Nombre del vendor",
					title: "Nombre",
					obs: "Observación",
					value: "Valor",
				},
			},
			columns: {
				originalPayDate: "Fecha de competencia",
				date: "Fecha de liquidación",
				vendorName: "Nombre del vendor",
				title: "Nombre",
				obs: "Observación",
				value: "Valor",
				category: "Categoría",
			},
			import: {
				vendorId: "Id del vendor",
				title: "Nombre del ajuste",
				value: "Valor (en centavos)",
				originalPayDate: "Fecha de competencia",
				date: "Fecha de liquidación",
				type: "Tipo de ajuste",
				category: "Categoría",
				obs: "Observación",
				importButton: "Importar ajustes",
				vendorName: "Nombre del vendor",
				successNotification: "Ajustes importados con éxito.",
				vendors: "Vendors",
				electrical: "Eléctrica",
				hydraulics: "Hidráulica",
				supply: "Provisión",
				cleaning: "Limpieza",
				other: "Otros",
				vendorIdTextError: "Error: Ingrese el Id del Vendor",
				vendorIdIsValidError: "Error: Ingrese un Id del Vendor válido",
				titleTextError: "Error: Ingrese un nombre al Ajuste",
				titleIsValidError: "Error: Nombre de ajuste con más de 255 caracteres",
				valueZeroError: "Error: Ingrese un valor de ajuste diferente de 0",
				valueCentsError:
					"¡Atención! El valor se informa en centavos, ej: 123 equivale a $ 1,23",
				categoryError: "Error: Ingrese una categoría de ajuste válida",
				obsError: "Error: Obs de ajuste con más de 255 caracteres",
			},
			total: "Total",
		},
		extractByVendor: {
			title: "Extracto por vendor",
			filename: "extracto-por-vendor",
			columns: {
				title: "Resumen del Período",
				titleValues: "Título",
				payValue: "Total",
			},
			selectPlaceholder: "Seleccione un vendor",
			available: "Saldo disponible",
			toBeReleased: "Anticipación disponible",
			emptyTitle: "Aún no hay nada por aquí",
			emptySubtitle: "Seleccione un vendor o verifique nuevamente más tarde.",
			themes: {
				retention: "Retención",
				productsCommissionPayment: "Tasa porcentual sobre facturación",
				productsSoldInPaymentMethods: "Tasa sobre métodos de pago",
				productsSold: "Ingreso con productos",
				tips: "Ingreso con servicio",
				adjustments: "Ajustes hechos por la casa",
			},
		},
	},
	adjustments: {
		form: {
			workingDayRequired:
				"La fecha de liquidación debe ser un día hábil (no se permiten fines de semana ni feriados)",
		},
		add: "Agregar nuevo ajuste",
		vendor: {
			label: "Vendor para registrar ajuste",
			placeholder: "Seleccione vendor para registrar los ajustes",
		},
		title: {
			label: "Nombre del ajuste",
			placeholder: "Ingrese el nombre del ajuste",
		},
		value: "Valor",
		date: "Fecha de liquidación",
		originalPayDate: "Fecha de competencia",
		type: {
			label: "Tipo de ajuste",
			vendorShouldPay: "A pagar al vendor",
			vendorShouldReceive: "A recibir del vendor",
		},
		obs: "Observación",
		electrical: "Eléctrica",
		hydraulics: "Hidráulica",
		cleaning: "Limpieza",
		supply: "Provisión",
		other: "Otros",
		category: "Categoría",
		categoryPlaceholder: "Seleccione una categoría",
	},
	withdraw: {
		title: "Solicitudes de retiro de {{name}}",
		requests: {
			title: "Requisiciones",
			label: "¿Desea confirmar las siguientes solicitudes de retiro y anticipación?",
			reject: "Rechazar seleccionadas",
			approve: "Aprobar seleccionadas",
			requestDate: "Solicitado en",
			availableValue: "saldo",
			anticipationValue: "Valor de Anticipación",
			prorata: "Valor de prorrata",
			totalValue: "Valor Total:",
			type: {
				label: "Tipo",
				withdraw: "Retiro",
				anticipation: "Anticipación",
			},
		},
		transference: {
			title: "Transferencia",
			warning: "ATENCIÓN",
			message:
				"Solicitudes realizadas después de las 10h30 (horario de Brasilia) solo serán atendidas al día siguiente.",
			typeMethod: {
				label: "Transferir con",
				zigAvailable: "Utilizar saldo Zig Pay",
				other: "Otro",
			},
			paymentMethod: {
				label: "Modo de pago",
				placeholder: "Informe el modo de pago",
			},
			attachments: "Anexos/Comprobantes",
			totalValue: "Valor del pago",
		},
	},
	pendingWithdraws: "Retiros pendientes",
	pendingAnticipations: "Anticipaciones pendientes",
	vendorsOwned: {
		seeDetails: "Ver detalles",
		name: "Nombre",
		total: "Total",
		alertTitle: "Cálculo de vendors",
		alertMessage:
			"Para el cálculo del valor debido a vendors solo se suman saldos positivos.",
		list: "Lista de Vendors",
	},
};
